/**
 * Bonus Engine Bonus Types
 */
enum BonusEngineBonusType {
  MONEY = 'MONEY',
  FREE_GAMES = 'FREE_GAMES',
}

export default BonusEngineBonusType
